module.exports = __webpack_public_path__ + "Roboto-BoldItalic.4b2cc52b05e2a960c4f1.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.eot
// module id = 95
// module chunks = 2